import { DESIGN_CONSOLE_ROUTE_NAMES } from '@apps/guest/shared/constants/designConsoleRouteNames';

// Guest owns the canonical values; re-exported here so all admin imports are unchanged.
// const + type with the same name mirrors the enum's dual value/type behavior.
export const DesignConsoleRouteName = DESIGN_CONSOLE_ROUTE_NAMES;
export type DesignConsoleRouteName = (typeof DESIGN_CONSOLE_ROUTE_NAMES)[keyof typeof DESIGN_CONSOLE_ROUTE_NAMES];

// Intended to be Pick<UseDesignConsoleRouterReturn, 'goTo' | 'goToDetailsTab'>
// However, Referencing UseDesignConsoleRouterReturn leads to a circular import.
export type DesignConsoleRouteComponentProps = Readonly<{
  goTo: (tabValue: string) => void;
  goToDetailsTab: () => void;
}>;

export type DesignConsoleRoute = Readonly<{
  name: DesignConsoleRouteName;
  component: (args: DesignConsoleRouteComponentProps) => React.ReactElement;
  label: string;
  icon: React.ReactElement;
  // Optional minimum width for the left side panel of the EditorV3 when this route is rendered
  minWidth?: number | string;
  // Optional maximum width for the left side panel of the EditorV3 when this route is rendered
  maxWidth?: number | string;
}>;

export type DesignConsoleTelemetryRouteName = DesignConsoleRouteName;

export type DesignConsoleTelemetryRoutes = DesignConsoleTelemetryRouteName | 'fullScreenPreview' | 'websiteDesignerPrintCrossSellDialog' | 'headerLayoutUpgradeDialog';
